export const prettyDate = (date: Date) => {
  if (!date) return { day: "TBD", month: "TBD" };

  const dateObj = date;
  return {
    day: dateObj.toLocaleDateString("en-US", { day: "numeric" }),
    month: dateObj.toLocaleDateString("en-US", { month: "short" }),
  };
};
